// extracted by mini-css-extract-plugin
export default {"input-main":"InputSection_input-main__--eaG","widthChange":"InputSection_widthChange__lnCTp"};